/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import moment from 'moment';
import { MnObject } from 'backbone.marionette';

const MomentFormatter = MnObject.extend({
  formatString: 'MM/DD/YYYY[&#x200b;] hh:mm[&nbsp;]a',

  fromRaw(rawValue) {
    const val = moment.isMoment(rawValue) ? rawValue : moment(rawValue, moment.ISO_8601);
    if (_.isNull(val) || !val.isValid()) {
      return '';
    } else {
      return val.format(this.formatString);
    }
  },
});

export default MomentFormatter;
